import { useI18n } from "@/i18n/I18nProvider";
import dynamic from "next/dynamic";
import { getHomePageData } from "@/services/get-homePage-data.js";
const PageHead = dynamic(() => import("@/components/PageHead"));
const Benifits = dynamic(() => import("@/components/mini-components/Benifits"));
const Outro = dynamic(() => import("@/components/mini-components/Outro"));
const ContactPaySection = dynamic(() =>
  import("../../sections/home/ContactPaySection.jsx")
);
// import CustomHeading from "@/components/custom-heading";

export default function Index({billPayment}) {
  const { t, locale } = useI18n();

  return (
    <>
      <PageHead
        title={t.pages_main_tags.epyament.title}
        description={t.pages_main_tags.epyament.meta_desc}
      />
      
      <ContactPaySection billpayment={billPayment}></ContactPaySection>
      <Benifits
        title={t.home_page.bos.benefits.title}
        list={t.home_page.bos.benefits.list}
      />
      <Outro outro={t.home_page.bos.outro} bgColor="#fff" />
    </>
  );
}
export async function getServerSideProps({ res }) {
  try {
    res.setHeader(
      "Cache-Control",
      "no-store, no-cache, must-revalidate, proxy-revalidate",
    );

    const { billPayment } =
      await getHomePageData();

    return {
      props: {
     
        billPayment: billPayment || [],
      },
    };
  } catch (error) {
    return {
      props: {
   
        billPayment:[],
      },

    };
  }
}